export default {
  title: 'Bestellung bestätigen',
  buttons: {
    view_product_allergens: 'Produktinfo ansehen',
    confirm: 'Weiter zur Zahlung',
    cancel: 'Zurück',
  },
  alert: {
    title: 'Wichtiger Hinweis zu Allergenen',
    description:
      'Bitte überprüfen Sie die Produktinformationen vor der Bestellung, wenn Sie Allergien oder Unverträglichkeiten haben.',
  },
};
